<ng-container *ngIf="noHeaderFooter; else standalone">
  <ng-container *ngTemplateOutlet="body"></ng-container>
</ng-container>

<ng-template #standalone>
  <div class="tw-w-full tw-h-fit tw-min-w-full tw-max-w-full tw-bg-background">
    <div class="tw-w-full tw-h-fit tw-max-w-screen-xl tw-mx-auto tw-bg-background tw-min-h-screen tw-flex tw-flex-col">
      <!-- Header -->
      <div class="tw-w-full tw-h-fit tw-sticky tw-top-5 tw-bg-transparent tw-z-[999] tw-px-8 md:tw-px-16">
        <div class="tw-w-full tw-h-fit tw-flex tw-flex-wrap tw-justify-between tw-items-center tw-bg-secondary tw-border tw-border-white/10 tw-rounded-[10px] tw-gap-2 tw-px-2 md:tw-px-4 tw-py-1">
          <div class="tw-w-fit tw-h-fit tw-flex tw-justify-start tw-items-center">
            <div class="tw-w-fit tw-h-full">
              <img class="tw-max-w-24 tw-min-h-12 tw-max-h-12 tw-object-contain tw-rounded-lg" src="../../../assets/logo.svg" />
            </div>
          </div>

          <div class="tw-w-fit tw-min-w-max tw-h-full tw-flex tw-justify-center tw-items-center tw-gap-2 md:tw-gap-4 tw-py-2 tw-relative">
            <button (click)="goToHome()" class="tw-w-fit tw-h-fit tw-bg-tertiary tw-font-poppins tw-font-semibold tw-text-xs tw-text-white tw-rounded-[5px] tw-px-4 tw-py-2">
              {{ "home" | translate }}
            </button>
            <p-dropdown
              class="language-flag-dropdown tw-border tw-border-white tw-rounded-[5px] tw-absolute tw-z-[1000]"
              [options]="languages"
              [(ngModel)]="selectedLanguage"
              [dataKey]="'id'"
              [filter]="false"
              [showClear]="false"
              [placeholder]="'language' | translate"
              (onChange)="setLanguage($event)"
            >
              <ng-template pTemplate="selectedItem" let-selectedOption class="tw-w-full tw-h-full tw-font-poppins tw-font-medium tw-text-sm tw-text-white">
                <div class="tw-flex tw-items-center tw-gap-2">
                  <span class="fi fi-{{ selectedOption.flag }}"></span>
                </div>
              </ng-template>
              <ng-template let-item pTemplate="item">
                <div class="tw-flex tw-items-center tw-gap-2">
                  <span class="fi fi-{{ item.flag }}"></span>
                </div>
              </ng-template>
            </p-dropdown>
          </div>
        </div>
      </div>

      <ng-container *ngTemplateOutlet="body"></ng-container>

      <!-- Footer -->
      <div class="tw-w-full tw-h-fit tw-bg-secondary 2xl:tw-rounded-[10px] tw-px-8 md:tw-px-16 tw-py-4 md:tw-pt-10 !tw-z-[3]">
        <div class="tw-w-full tw-flex max-md:tw-flex-col tw-justify-between tw-gap-10 md:tw-mb-10">
          <div class="tw-w-full md:tw-max-w-xs tw-flex tw-flex-col tw-gap-4">
            <div class="tw-w-fit tw-h-full">
              <img class="tw-max-w-24 tw-min-h-12 tw-max-h-12 tw-object-contain tw-rounded-lg" src="../../../assets/logo.svg" />
            </div>
            <p class="tw-font-poppins tw-text-xs tw-text-white/50">{{ "home-description" | translate }}</p>
            <div class="tw-flex tw-items-center tw-gap-4">
              <img class="tw-min-w-6 tw-max-w-6 tw-min-h-6 tw-max-h-6 tw-object-contain tw-cursor-pointer" (click)="goToSocilMedia('instagram')" src="../../../assets/footer-instagram-icon.svg" />
              <img class="tw-min-w-6 tw-max-w-6 tw-min-h-6 tw-max-h-6 tw-object-contain tw-cursor-pointer" (click)="goToSocilMedia('facebook')" src="../../../assets/footer-facebook-icon.svg" />
              <img class="tw-min-w-6 tw-max-w-6 tw-min-h-6 tw-max-h-6 tw-object-contain tw-cursor-pointer" (click)="goToSocilMedia('tiktok')" src="../../../assets/footer-tiktok-icon.svg" />
            </div>
          </div>

          <div class="tw-flex tw-gap-16 max-md:tw-gap-10">
            <div class="tw-flex tw-flex-col tw-gap-3">
              <p class="tw-font-poppins tw-font-semibold tw-text-xs tw-text-white/40 tw-uppercase tw-tracking-wider">{{ "legal" | translate }}</p>
              <p (click)="goToPrivacyPolicy()" class="tw-font-poppins tw-text-xs tw-text-white/70 hover:tw-text-white tw-cursor-pointer">{{ "privacy-policy" | translate }}</p>
              <p (click)="goToTermsOfService()" class="tw-font-poppins tw-text-xs tw-text-white/70 hover:tw-text-white tw-cursor-pointer">{{ "terms-of-service" | translate }}</p>
            </div>
          </div>

          <div class="tw-w-full md:tw-w-fit">
            <p class="tw-font-poppins tw-font-semibold tw-text-xs tw-text-white/50 tw-mb-4">{{ "create-an-account-footer-label" | translate }}</p>
            <button (click)="goToRegister()" class="tw-w-full md:tw-min-w-[150px] tw-bg-primary tw-font-poppins tw-font-semibold tw-text-xs tw-text-secondary tw-rounded-[5px] tw-px-4 tw-py-3">
              {{ "create-a-business-account" | translate }}
            </button>
          </div>
        </div>

        <div class="tw-w-full tw-h-px tw-bg-white/10 tw-my-6"></div>

        <p class="tw-font-poppins tw-text-xs tw-text-white/40 tw-text-center">{{ "copyright" | translate }}</p>
      </div>
      <div class="tw-w-full tw-h-5 max-2xl:tw-hidden"></div>
    </div>
  </div>
</ng-template>

<ng-template #body>
  <div class="tw-w-full tw-flex-1 tw-bg-background tw-flex tw-flex-col">
    <!-- Deliver to -->
    <div class="tw-w-full tw-px-8 md:tw-px-16 tw-pt-10">
      <button
        type="button"
        [disabled]="disableButton"
        (click)="openLocationSearch()"
        [ngClass]="{ 'tw-opacity-60 tw-cursor-not-allowed': disableButton }"
        class="tw-w-full tw-flex tw-items-center tw-gap-3 tw-bg-white hover:tw-bg-grey-100 tw-border tw-border-grey-600 tw-rounded-[10px] tw-px-4 tw-py-3 tw-text-left tw-transition-colors"
      >
        <span class="tw-w-9 tw-h-9 tw-min-w-9 tw-flex tw-justify-center tw-items-center tw-rounded-full tw-bg-primary/20">
          <svg class="tw-w-4 tw-h-4 tw-fill-primary" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M18.9135 17.5854L17.6771 18.8083C16.7659 19.7021 15.5833 20.8521 14.1291 22.2583C13.6921 22.6809 13.1079 22.9171 12.5 22.9171C11.892 22.9171 11.3079 22.6809 10.8708 22.2583L7.23435 18.7208C6.77671 18.2722 6.39407 17.8937 6.08643 17.5854C4.81806 16.317 3.95431 14.7009 3.60441 12.9415C3.2545 11.1822 3.43415 9.35857 4.12064 7.70132C4.80713 6.04407 5.96963 4.6276 7.46113 3.63103C8.95264 2.63446 10.7062 2.10254 12.5 2.10254C14.2938 2.10254 16.0473 2.63446 17.5388 3.63103C19.0303 4.6276 20.1928 6.04407 20.8793 7.70132C21.5658 9.35857 21.7454 11.1822 21.3955 12.9415C21.0456 14.7009 20.1819 16.317 18.9135 17.5854ZM15.1041 11.4583C15.1041 10.7677 14.8298 10.1053 14.3414 9.6169C13.853 9.12853 13.1906 8.85416 12.5 8.85416C11.8093 8.85416 11.1469 9.12853 10.6585 9.6169C10.1702 10.1053 9.8958 10.7677 9.8958 11.4583C9.8958 12.149 10.1702 12.8114 10.6585 13.2998C11.1469 13.7881 11.8093 14.0625 12.5 14.0625C13.1906 14.0625 13.853 13.7881 14.3414 13.2998C14.8298 12.8114 15.1041 12.149 15.1041 11.4583Z"
            />
          </svg>
        </span>
        <span class="tw-flex-1 tw-min-w-0">
          <p class="tw-text-xs tw-text-secondary/50 tw-font-poppins tw-font-medium">{{ "deliver-to" | translate }}</p>
          <p class="tw-text-xs tw-font-poppins tw-font-medium tw-text-secondary tw-truncate">{{ currentAddress || ("current-location" | translate) }}</p>
        </span>
        <svg class="tw-w-5 tw-h-5 tw-fill-none tw-stroke-secondary/80" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path d="m6 9 6 6 6-6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </button>
    </div>

    <!-- Banners -->
    <div *ngIf="showBanners" class="tw-w-full tw-px-8 md:tw-px-16 tw-pt-4">
      <p-carousel
        [value]="businessData.banners"
        [numVisible]="2"
        [numScroll]="1"
        [responsiveOptions]="bannerResponsiveOptions"
        [circular]="true"
        [showNavigators]="true"
        [showIndicators]="true"
        [autoplayInterval]="5000"
        styleClass="tw-w-full banners-carousel"
      >
        <ng-template let-banner pTemplate="item">
          <div class="tw-w-full tw-h-40 md:tw-h-56 tw-rounded-[20px] tw-overflow-hidden tw-bg-secondary">
            <img class="tw-w-full tw-h-full tw-object-cover" [src]="banner.bannerURL" />
          </div>
        </ng-template>
      </p-carousel>
    </div>

    <!-- Search -->
    <div class="tw-w-full tw-px-8 md:tw-px-16 tw-pt-4 tw-mb-6">
      <div class="tw-w-full tw-h-12 tw-relative tw-flex tw-items-center tw-bg-white tw-border tw-border-grey-600 tw-rounded-[10px] tw-px-4">
        <input
          #searchInput
          class="tw-w-full tw-h-full tw-font-poppins tw-font-medium tw-text-sm tw-bg-transparent tw-text-secondary placeholder:tw-text-grey-400 tw-outline-none tw-pr-8"
          [(ngModel)]="search"
          (change)="setSearch($event)"
          [placeholder]="'search-here' | translate"
        />
        <img class="tw-w-5 tw-h-5 tw-object-contain tw-absolute tw-right-4" src="../../../assets/search-icon.svg" />
      </div>
    </div>

    <!-- Category chips -->
    <div class="tw-w-full tw-h-fit tw-px-8 md:tw-px-16 tw-overflow-hidden tw-py-2">
      <div class="tw-w-full tw-flex tw-items-center tw-gap-2 tw-overflow-x-auto">
        <button
          *ngFor="let category of categories"
          type="button"
          (click)="selectCategory(category)"
          [ngClass]="
            selectedCategory.id === category.id ? 'tw-bg-primary tw-text-secondary tw-border tw-border-primary' : 'tw-bg-white tw-text-secondary tw-border tw-border-grey-600 hover:tw-bg-grey-100'
          "
          class="tw-whitespace-nowrap tw-flex tw-items-center tw-gap-1 tw-rounded-full tw-px-3 tw-py-2 tw-text-xs tw-font-poppins tw-font-semibold tw-transition-colors"
        >
          <span *ngIf="category.emoji">{{ category.emoji }}</span>
          {{ category.name | translate }}
        </button>
      </div>
    </div>

    <!-- Loading -->
    <div *ngIf="locationLoading" class="tw-w-full tw-flex tw-justify-center tw-items-center tw-gap-3 tw-py-14">
      <div class="tw-w-5 tw-h-5 tw-border-2 tw-border-primary tw-border-t-transparent tw-rounded-full tw-animate-spin"></div>
      <p class="tw-font-poppins tw-font-medium tw-text-xs tw-text-secondary/50">{{ "loading" | translate }}</p>
    </div>

    <!-- No results -->
    <div *ngIf="!locationLoading && branches.length == 0" class="tw-w-full tw-flex tw-justify-center tw-items-center tw-gap-3 tw-py-14">
      <p class="tw-font-poppins tw-font-semibold tw-text-xs tw-text-secondary/50 tw-text-center">{{ "no-results-found" | translate }}</p>
    </div>

    <!-- Places list -->
    <div
      *ngIf="!locationLoading && branches.length > 0"
      class="tw-flex-1 tw-w-full tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 lg:tw-grid-cols-3 xl:tw-grid-cols-4 tw-gap-4 tw-px-8 md:tw-px-16 tw-pt-6 tw-pb-10"
    >
      <div
        *ngFor="let branch of branches"
        (click)="goToBusiness(branch)"
        [ngClass]="getBranchIsOpen(branch) ? 'tw-cursor-pointer hover:tw-border-grey-400' : 'tw-cursor-not-allowed tw-opacity-50'"
        class="tw-w-full tw-max-h-min tw-rounded-[10px] tw-overflow-hidden tw-bg-white tw-border tw-border-grey-600 tw-transition-colors"
      >
        <div class="tw-w-full tw-h-40 tw-bg-secondary tw-relative tw-flex tw-justify-center tw-items-center">
          <img *ngIf="branch.business?.bannerURL" class="tw-w-full tw-h-full tw-object-cover" [src]="branch.business.bannerURL" />
          <svg *ngIf="!branch.business?.bannerURL" class="tw-w-10 tw-h-10 tw-fill-primary/70" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M1.5 6a2.25 2.25 0 0 1 2.25-2.25h16.5A2.25 2.25 0 0 1 22.5 6v12a2.25 2.25 0 0 1-2.25 2.25H3.75A2.25 2.25 0 0 1 1.5 18V6ZM3 16.06V18c0 .414.336.75.75.75h16.5A.75.75 0 0 0 21 18v-1.94l-2.69-2.689a1.5 1.5 0 0 0-2.12 0l-.88.879.97.97a.75.75 0 1 1-1.06 1.06l-5.16-5.159a1.5 1.5 0 0 0-2.12 0L3 16.061Zm10.125-7.81a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0Z"
            />
          </svg>
        </div>

        <div class="tw-w-full tw-flex tw-flex-col tw-gap-2 tw-p-4">
          <div class="tw-w-full tw-flex tw-justify-between tw-items-start tw-gap-2">
            <p class="tw-flex-1 tw-min-w-0 tw-truncate tw-font-poppins tw-font-semibold tw-text-sm tw-text-secondary">
              {{ branch.business?.display_name }}
              <span *ngIf="shouldShowBranchName(branch)" class="tw-text-secondary/80 tw-font-light"> - {{ branch.name }}</span>
            </p>
          </div>

          <div class="tw-w-full tw-min-h-16 tw-flex tw-items-center tw-gap-2 tw-flex-wrap tw-content-start tw-pt-1">
            <span *ngIf="!getBranchIsOpen(branch)" class="tw-flex tw-items-center tw-gap-1 tw-bg-danger/30 tw-rounded-full tw-px-3 tw-py-1">
              <div class="tw-w-2 tw-h-2 tw-rounded-full tw-bg-danger"></div>
              <span class="tw-font-poppins tw-text-[11px] tw-text-secondary/80">{{ "closed" | translate }}</span>
            </span>
            <span *ngIf="getBranchIsOpen(branch)" class="tw-flex tw-items-center tw-gap-1 tw-bg-success/30 tw-rounded-full tw-px-3 tw-py-1">
              <div class="tw-w-2 tw-h-2 tw-rounded-full tw-bg-success"></div>
              <span class="tw-font-poppins tw-text-[11px] tw-text-secondary/80">{{ "open-until" | translate }} {{ branch.end_hour }}</span>
            </span>
            <span *ngIf="branch.eta_min && branch.eta_max && branch.eta_min > 0 && branch.eta_max > 0" class="tw-flex tw-items-center tw-gap-1 tw-bg-grey-100 tw-rounded-full tw-px-3 tw-py-1">
              <svg class="tw-w-3 tw-h-3 tw-fill-secondary/80" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M15 2.5C21.9037 2.5 27.5 8.09625 27.5 15C27.5 21.9037 21.9037 27.5 15 27.5C8.09625 27.5 2.5 21.9037 2.5 15C2.5 8.09625 8.09625 2.5 15 2.5ZM15 5C12.3478 5 9.8043 6.05357 7.92893 7.92893C6.05357 9.8043 5 12.3478 5 15C5 17.6522 6.05357 20.1957 7.92893 22.0711C9.8043 23.9464 12.3478 25 15 25C17.6522 25 20.1957 23.9464 22.0711 22.0711C23.9464 20.1957 25 17.6522 25 15C25 12.3478 23.9464 9.8043 22.0711 7.92893C20.1957 6.05357 17.6522 5 15 5ZM15 7.5C15.3062 7.50004 15.6017 7.61244 15.8305 7.81589C16.0593 8.01934 16.2054 8.29969 16.2413 8.60375L16.25 8.75V14.4825L19.6337 17.8663C19.8579 18.0912 19.9881 18.393 19.9978 18.7105C20.0075 19.0279 19.896 19.3371 19.6859 19.5753C19.4759 19.8136 19.1831 19.9629 18.8669 19.993C18.5508 20.0231 18.235 19.9318 17.9838 19.7375L17.8663 19.6337L14.1163 15.8837C13.922 15.6893 13.7972 15.4363 13.7612 15.1637L13.75 15V8.75C13.75 8.41848 13.8817 8.10054 14.1161 7.86612C14.3505 7.6317 14.6685 7.5 15 7.5Z"
                />
              </svg>
              <span class="tw-font-poppins tw-text-[11px] tw-text-secondary/80">{{ getBranchEta(branch) }}</span>
            </span>
            <span *ngIf="branchMinOrder(branch) > 0" class="tw-flex tw-items-center tw-gap-1 tw-bg-grey-100 tw-rounded-full tw-px-3 tw-py-1">
              <svg class="tw-w-3 tw-h-3 tw-fill-secondary/80" viewBox="0 0 38 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M36.0937 0H24.8437C24.0712 0 22.9893 0.448125 22.4437 0.99375L8.49557 14.9419C8.3649 15.0725 8.26123 15.2275 8.19051 15.3982C8.11978 15.5689 8.08337 15.7518 8.08337 15.9366C8.08337 16.1213 8.11978 16.3042 8.19051 16.4749C8.26123 16.6456 8.3649 16.8007 8.49557 16.9312L20.5687 29.0044C20.6993 29.1351 20.8544 29.2387 21.025 29.3094C21.1957 29.3802 21.3786 29.4166 21.5634 29.4166C21.7481 29.4166 21.9311 29.3802 22.1017 29.3094C22.2724 29.2387 22.4275 29.1351 22.5581 29.0044L36.5062 15.0562C37.0537 14.5087 37.4999 13.4288 37.4999 12.6562V1.40625C37.4999 1.03329 37.3518 0.675604 37.0881 0.411881C36.8243 0.148158 36.4667 0 36.0937 0ZM29.0624 11.25C28.693 11.2499 28.3272 11.177 27.9859 11.0355C27.6446 10.894 27.3345 10.6866 27.0733 10.4253C26.8122 10.164 26.605 9.85374 26.4637 9.51235C26.3225 9.17096 26.2498 8.80509 26.2499 8.43563C26.2501 8.06616 26.323 7.70034 26.4645 7.35904C26.606 7.01775 26.8133 6.70766 27.0746 6.4465C27.336 6.18533 27.6462 5.9782 27.9876 5.83693C28.329 5.69565 28.6949 5.623 29.0643 5.62313C29.8105 5.62337 30.526 5.92003 31.0534 6.44782C31.5809 6.97562 31.8771 7.69133 31.8768 8.4375C31.8766 9.18367 31.5799 9.89918 31.0521 10.4266C30.5243 10.9541 29.8086 11.2502 29.0624 11.25Z"
                />
                <path
                  d="M3.74995 15.9375L19.6874 0H17.3437C16.5712 0 15.4893 0.448125 14.9437 0.99375L0.995574 14.9419C0.864896 15.0725 0.761232 15.2275 0.690505 15.3982C0.619778 15.5689 0.583374 15.7518 0.583374 15.9366C0.583374 16.1213 0.619778 16.3042 0.690505 16.4749C0.761232 16.6456 0.864896 16.8007 0.995574 16.9312L13.0687 29.0044C13.1993 29.1351 13.3544 29.2387 13.525 29.3094C13.6957 29.3802 13.8786 29.4166 14.0634 29.4166C14.2481 29.4166 14.4311 29.3802 14.6017 29.3094C14.7724 29.2387 14.9275 29.1351 15.0581 29.0044L15.9393 28.1231L3.74995 15.9375Z"
                />
              </svg>
              <span class="tw-font-poppins tw-text-[11px] tw-text-secondary/80">{{ getBranchMinOrder(branch) }}</span>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
